import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

import footerComponent from '../../common/footerComponent/index.vue'
import card from "@/components/assets/user/card/index.vue";

export default {
    name: 'panel',
    props: {
    },

    data : function(){

        return {
            loading : false
        }

    },

    components : {footerComponent, card},

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        userinfo : state => state.userinfo,
        panels : function(){

            var panels = [
                {
                    id : 'team',
                    text : 'labels.users',
                    features : ['team'],
                    route : 'panel_users'
                },
                {
                    id : 'moderation',
                    text : 'labels.moderation',
                    features : ['moderation'],
                    route : 'panel_moderation'
                },
                {
                    id : 'earnings',
                    text : 'labels.earnings',
                    features : ['promo', 'team'],
                    route : 'panel_earnings'
                },

                {
                    id : 'promo',
                    text : 'plans.promoCaptions',
                    features : ['promo'],
                    route : 'panel_promocodes'
                },

                {
                    id : 'partnerinfo',
                    text : 'plans.partnerinfo',
                    features : ['promounmoderated'],
                    route : 'panel_partnerinfo'
                },

                {
                    id : 'payments',
                    text : 'plans.paymentsCaptions',
                    features : ['admin'],
                    route : 'panel_payments'
                },
                
               
            ]

            return this.core.user.extendByFeatures(panels)
        },

        actions : function(){

            var panels = _.filter([

                {
                    id : 'cancreatecoursebutton',
                    text : 'snippity.cancreatecoursebutton',
                    features : ['admin'],
                    action : this.createLessons
                },

                {
                    id : 'updateseo',
                    text : 'snippity.updateseo',
                    features : ['admin'],
                    action : this.updateseo
                },


                

                this.newsRunned ? null : {
                    id : 'runnews',
                    text : 'snippity.runnews',
                    features : ['admin'],
                    action : this.runNews
                }
                
               
            ], (n) => {return n})

            return this.core.user.extendByFeatures(panels)
        },

        newsRunned: function(){
            return f.deep(this.core, 'appInfo.snippity.settings.newsRunned') || false
        },
    }),

    methods : {
        runNews : function(){
            this.core.promwrapper(this.core.api.news.admin.run(), { } ).then(() => {

            }).catch(e => {
                console.error(e)
            })
        },

        updateseo : function(){
            this.core.promwrapper(this.core.api.admin.seo(), { } ).then(() => {

            }).catch(e => {
                console.error(e)
            })
        },

        createLessons : function(){
            this.core.vueapi.coursecreate({
                admin : true
            })

            
        },
        clictItem : function(panel){

            if(panel.route){
                this.$router.push({name : panel.route})
            }
            
            if(panel.action){
                panel.action()
            }
            
        }
    },
}